import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import { uiReducer } from '../reducers/uiReducer';

const reducers = combineReducers({
    ui: uiReducer
});

export const store = createStore(
    reducers,
    composeWithDevTools(
        applyMiddleware(thunk)
    )
); 